import React, { useState, useEffect, useRef } from 'react';
// import './PhotographyServices.css';

const PhotographyServices = () => {
    const [currentIndex, setCurrentIndex] = useState(2);
    // Use a ref to keep track of the auto-slide timer interval id
    const timerRef = useRef(null);

    const services = [
        { title: "Pre Wedding & Wedding", desc: "Timeless love stories written through a lens of classic elegance.", url: "#wedding", bg: "https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=800" },
        { title: "Modelling & Acting", desc: "Expressive portfolios designed to get you noticed by agencies.", url: "#wedding", bg: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=800" },
        { title: "Commercial & Industrial", desc: "Bold imagery designed to capture production, scale, and enterprise precision.", url: "#wedding", bg: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=800" },
        { title: "Fashion & Beauty", desc: "High-contrast, striking imagery highlighting garments and cosmetic details.", url: "#prewedding", bg: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=800" },
        { title: "Products & Brands", desc: "Commercial grade product layouts built to upscale store conversions.", url: "#portrait", bg: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?q=80&w=800" },
        { title: "Events & Celebrations", desc: "Documenting high-energy celebrations, milestones, and parties smoothly.", url: "#portrait", bg: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=800" },
        { title: "Creative & Arts", desc: "Conceptual fine-art layouts turning raw thoughts into imagery poetry.", url: "#portrait", bg: "https://images.unsplash.com/photo-1513364776144-60967b0f800f?q=80&w=800" }
    ];

    const handlePrev = () => {
        setCurrentIndex((prev) => (prev === 0 ? services.length - 1 : prev - 1));
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev === services.length - 1 ? 0 : prev + 1));
    };

    // Starts the auto-rotation loop
    const startAutoSlide = () => {
        stopAutoSlide(); // Clear any existing intervals first to prevent memory leaks/double triggers
        timerRef.current = setInterval(() => {
            handleNext();
        }, 3500); // Slides every 3.5 seconds
    };

    // Stops the loop on user interaction/hover
    const stopAutoSlide = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }
    };

    // Starts the slide effect on mount, cleans up on unmount
    useEffect(() => {
        startAutoSlide();
        return () => stopAutoSlide();
    }, [currentIndex]); // Resets timer alignment whenever index state updates

    return (
        <section className="photography-services-section py-5 overflow-hidden">
            <div className="container-fluid text-center mb-5">
                <h5 className="text-uppercase tracking-wider text-orange fw-bold mb-2">Our Offerings</h5>
                <h2 className="display-5 text-white fw-bold text-uppercase">Photography Services</h2>
            </div>

            {/* Pauses sliding loop on MouseEnter, restarts it on MouseLeave */}
            <div 
                className="coverflow-container-fluid"
                onMouseEnter={stopAutoSlide}
                onMouseLeave={startAutoSlide}
            >
                <div className="coverflow-track">
                    {services.map((item, index) => {
                        const offset = index - currentIndex;
                        const absOffset = Math.abs(offset);
                        
                        let transformStyle = '';
                        let zIndex = 100 - absOffset;
                        let opacity = 1;

                        if (absOffset > 2) {
                            opacity = 0; 
                        }

                        if (offset === 0) {
                            transformStyle = 'translateX(0%) scale(1) rotateY(0deg) translateZ(200px)';
                        } else if (offset < 0) {
                            transformStyle = `translateX(calc(${offset * 70}% - 50px)) scale(0.85) rotateY(42deg) translateZ(0px)`;
                        } else if (offset > 0) {
                            transformStyle = `translateX(calc(${offset * 70}% + 50px)) scale(0.85) rotateY(-42deg) translateZ(0px)`;
                        }

                        return (
                            <div
                                key={index}
                                className={`coverflow-card ${offset === 0 ? 'active' : ''}`}
                                style={{
                                    transform: transformStyle,
                                    zIndex: zIndex,
                                    opacity: opacity,
                                    backgroundImage: `linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.65)), url("${item.bg}")`
                                }}
                                onClick={() => setCurrentIndex(index)}
                            >
                                <div className="card-inner-content">
                                    <span className="brand-sub">Arven Studio</span>
                                    <h3 className="service-card-title">{item.title}</h3>
                                    <p className="service-card-desc">{item.desc}</p>
                                    <a className="btn-gallery-pill" href={item.url}>
                                        See The Gallery
                                    </a>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <button className="nav-3d-btn btn-prev" onClick={handlePrev} aria-label="Previous Slide">
                    <i className="fa-solid fa-chevron-left" />
                </button>
                <button className="nav-3d-btn btn-next" onClick={handleNext} aria-label="Next Slide">
                    <i className="fa-solid fa-chevron-right" />
                </button>
            </div>
        </section>
    );
};

export default PhotographyServices;